/* Lauren's Label — Collection toolbar (Filter / Sort / Grid toggle)
 * Fixed: event delegation so listeners survive Dawn's facets.js DOM replacement.
 * Fixed: visible close (×) button injected into the filter drawer header.
 * Fixed: clicking the dimmed overlay area now closes the drawer.
 */
(function () {
  'use strict';

  var GRID_STORAGE_KEY = 'll_collection_grid_v1';
  var CLOSE_BTN_ATTR = 'data-ll-filter-close';
  var STYLE_ID = 'll-ctb-injected-styles';

  /* ---------- Style injection ---------- */
  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = [
      /* Visible close X in drawer header */
      '.ll-filter-close{',
      '  flex:0 0 auto;margin-left:auto;width:36px;height:36px;',
      '  display:inline-flex;align-items:center;justify-content:center;',
      '  background:transparent;border:0;color:#1a2a3a;cursor:pointer;',
      '  border-radius:50%;transition:background .15s ease;padding:0;',
      '}',
      '.ll-filter-close:hover,.ll-filter-close:focus-visible{',
      '  background:rgba(26,42,58,.08);outline:none;',
      '}',
      /* Make the drawer dimmed area clickable so users kan close by klicking outside */
      '.mobile-facets__wrapper details[open] .mobile-facets{pointer-events:auto;}',
      '.mobile-facets__wrapper details[open] .mobile-facets__inner{pointer-events:auto;}',
    ].join('');
    document.head.appendChild(s);
  }

  /* ---------- Drawer helpers ---------- */
  function getDrawerSummary() {
    return document.querySelector('.mobile-facets__wrapper summary');
  }

  function openFilterDrawer() {
    var summary = getDrawerSummary();
    if (summary) summary.click();
  }

  function closeFilterDrawer() {
    var details = document.querySelector('.mobile-facets__disclosure[open]');
    if (!details) return;
    // Native <details> close via summary click (also lets Dawn's menu-drawer JS clean up)
    var summary = details.querySelector('summary');
    if (summary) summary.click();
    // Belt-and-suspenders: always restore scroll
    document.body.classList.remove('overflow-hidden', 'overflow-hidden-mobile');
    document.body.style.overflow = '';
  }

  function injectFilterCloseButton() {
    var header = document.querySelector('.mobile-facets__header');
    if (!header) return;
    if (header.querySelector('[' + CLOSE_BTN_ATTR + ']')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'll-filter-close';
    btn.setAttribute(CLOSE_BTN_ATTR, '');
    btn.setAttribute('aria-label', 'Close filter');
    btn.innerHTML =
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">' +
      '<path d="M6 6l12 12M18 6L6 18" stroke-linecap="round"/></svg>';
    header.appendChild(btn);
  }

  /* ---------- Sort drawer ---------- */
  function openSort() {
    var sort = document.querySelector('[data-ll-sort]');
    if (!sort) return;
    sort.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeSort() {
    var sort = document.querySelector('[data-ll-sort]');
    if (!sort) return;
    sort.hidden = true;
    document.body.style.overflow = '';
  }

  /* ---------- Grid view ---------- */
  function applyGrid(cols) {
    var grid = document.getElementById('product-grid');
    if (grid) {
      grid.classList.remove('ll-grid-1', 'll-grid-2');
      grid.classList.add('ll-grid-' + cols);
    }
    document.body.classList.remove('ll-grid-1', 'll-grid-2');
    document.body.classList.add('ll-grid-' + cols);

    document.querySelectorAll('[data-ll-ctb-grid]').forEach(function (btn) {
      btn.classList.toggle(
        'll-ctb__grid-btn--active',
        btn.getAttribute('data-ll-ctb-grid') === String(cols)
      );
    });
  }

  function loadSavedGrid() {
    var saved = null;
    try { saved = localStorage.getItem(GRID_STORAGE_KEY); } catch (e) {}
    applyGrid(saved === '1' ? 1 : 2);
  }

  /* ---------- Delegated handlers (survive DOM replacement) ---------- */
  function handleClick(e) {
    var t = e.target;

    // Sort drawer overlay or close
    if (t.closest('[data-ll-sort-close]')) {
      closeSort();
      return;
    }

    // Filter drawer close X
    if (t.closest('[' + CLOSE_BTN_ATTR + ']')) {
      closeFilterDrawer();
      return;
    }

    // Click on dimmed overlay (not on drawer inner panel) -> close
    var drawerOpen = document.querySelector('.mobile-facets__disclosure[open]');
    if (drawerOpen && t.closest('.mobile-facets') && !t.closest('.mobile-facets__inner')) {
      closeFilterDrawer();
      return;
    }

    // Toolbar buttons
    if (t.closest('[data-ll-ctb-filter]')) {
      openFilterDrawer();
      return;
    }
    if (t.closest('[data-ll-ctb-sort]')) {
      openSort();
      return;
    }
    var gridBtn = t.closest('[data-ll-ctb-grid]');
    if (gridBtn) {
      var cols = gridBtn.getAttribute('data-ll-ctb-grid');
      applyGrid(cols);
      try { localStorage.setItem(GRID_STORAGE_KEY, cols); } catch (err) {}
      return;
    }
  }

  function handleChange(e) {
    if (e.target && e.target.name === 'sort_by' && e.target.closest('[data-ll-sort-form]')) {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', e.target.value);
      window.location.search = params.toString();
    }
  }

  function handleKeydown(e) {
    if (e.key !== 'Escape') return;
    var sort = document.querySelector('[data-ll-sort]');
    if (sort && !sort.hidden) { closeSort(); return; }
    var drawerOpen = document.querySelector('.mobile-facets__disclosure[open]');
    if (drawerOpen) { closeFilterDrawer(); }
  }

  /* ---------- Drawer toggle observer -> inject close X when opened ---------- */
  function watchDrawer() {
    var drawer = document.querySelector('.mobile-facets__disclosure');
    if (!drawer || drawer._llWatched) return;
    drawer._llWatched = true;
    drawer.addEventListener('toggle', function () {
      if (drawer.open) {
        injectFilterCloseButton();
      } else {
        // Restore body scroll explicitly
        document.body.classList.remove('overflow-hidden', 'overflow-hidden-mobile');
        document.body.style.overflow = '';
      }
    });
  }

  /* ---------- Init ---------- */
  function init() {
    injectStyles();

    if (!window.__llCtbBound) {
      document.addEventListener('click', handleClick);
      document.addEventListener('change', handleChange);
      document.addEventListener('keydown', handleKeydown);
      window.__llCtbBound = true;
    }

    loadSavedGrid();
    watchDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-apply grid state and re-attach drawer watcher after facets.js replaces
     #ProductGridContainer (which wipes the toolbar HTML). */
  function startObserver() {
    var target = document.getElementById('ProductGridContainer');
    if (!target) return;
    var mo = new MutationObserver(function () {
      loadSavedGrid();
      watchDrawer();
    });
    mo.observe(target, { childList: true, subtree: false });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();
